export { default } from './MailSentEvent';
